import { MailConfig } from './mail-config';

export interface PentestMailConfigUpdateRequest {
  recipients: string[];
}

export namespace PentestMailConfigUpdateRequest {
  export function mapToApiValue({ recipients }: MailConfig): PentestMailConfigUpdateRequest {
    return {
      recipients,
    };
  }
}
